/* unplugin-vue-components disabled */import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "map-address"
};
const _hoisted_2 = {
  class: "address-list"
};
const _hoisted_3 = ["onClick"];
export default {
  __name: 'index',
  setup(__props, {
    emit: __emit
  }) {
    const {
      proxy
    } = getCurrentInstance();
    const emit = __emit;
    const lng = ref(108.956910);
    const lat = ref(34.263710);
    const map = ref({});
    const marker = ref({});
    const T = ref(window.T);
    const addressList = ref([]);
    const searchAddresKeywords = ref("");
    const addressInfo = reactive({
      longitude: "",
      // 经度
      latitude: "",
      // 纬度
      province: "",
      // 省
      city: "",
      // 市
      county: "",
      // 区
      address: "" // 详细地址
    });
    watch(searchAddresKeywords, val => {
      if (!val) {
        addressList.value = [];
        // 用来清空删除太快时候出现列表的bug
        setTimeout(() => {
          addressList.value = [];
        }, 3000);
      }
    });
    function initMap() {
      nextTick(() => {
        //这里T指向天地图对象
        //初始化地图，创建一个新的地图实例
        //其中 `T.Map` 接收的第一个参数是在html中天地图标签的ID
        //第二个参数是天地图的参考系，我这里设置的是 `EPSG:4326`，也就是WGS84 坐标参考系。
        map.value = new T.value.Map("map-containera", "EPSG:4326");
        //这一步调用了天地图的setMapType方法，用来设置天地图的图层类型，我这里设置的是卫星图图层
        map.value.setMapType(window.TMAP_HYBRID_MAP);
        //这一步设置的是地图的初始化后的中心点坐标以及缩放级别
        //做完这一步，天地图就以及能在地图上显示出来了
        map.value.centerAndZoom(new T.value.LngLat(lng.value, lat.value), 13);
        //创建坐标拾取组件，并设置回调函数，该组件会将拾取到的坐标点传给回调函数
        var cp = new T.value.CoordinatePickup(map.value, {
          callback: handChoose
        });
        //启用坐标拾取功能
        cp.addEvent();
      });
    }

    //选点功能
    const handChoose = lnglat => {
      //如果存在标记，删除
      map.value.clearOverLays();
      //更新当前选取的坐标点
      lng.value = lnglat.lng.toFixed(6);
      lat.value = lnglat.lat.toFixed(6);
      emit("setPosition", [lng.value, lat.value]);
      //调用天地图Marker方法，生成标记,将marker渲染在页面上
      map.value.addOverLay(new T.value.Marker(T.value.LngLat(lng.value, lat.value)));
      /** 逆向解析地址 point */
      const geocoder = new T.value.Geocoder();
      geocoder.getLocation(T.value.LngLat(lng.value, lat.value), result => {
        // 设置基本信息
        const add = result.addressComponent;
        addressInfo.longitude = lng.value;
        addressInfo.latitude = lat.value;
        addressInfo.province = add.province;
        addressInfo.city = add.city;
        addressInfo.county = add.county;
        addressInfo.address = add.address;
        emit("setAddress", addressInfo);
      });
    };

    //input输入框监听事件
    function searchWithName(val) {
      if (val) {
        var config = {
          pageCapacity: 10,
          //每页显示的数量
          onSearchComplete: localSearchResult //接收数据的回调函数
        };
        //创建搜索对象
        let localsearch = new T.value.LocalSearch(map.value, config);
        localsearch.search(searchAddresKeywords.value, 1);
      } else {
        addressList.value = [];
      }
    }
    function localSearchResult(result) {
      //清空地图及搜索列表
      map.value.clearOverLays();
      //解析建议词信息
      if (result.getPois() && result.getPois().length) {
        //建议词提示，如果搜索类型为公交规划建议词或公交站搜索时，返回结果为公交信息的建议词。
        addressList.value = result.getPois();
      }
    }

    //下拉选择调用
    function selectOneAddr(val) {
      map.value.clearOverLays();
      //创建对象
      let geocoder = new T.value.Geocoder();
      geocoder.getPoint(val, searchResult);
    }
    function searchResult(result) {
      if (result.status === "0") {
        let lng = result.location.lon;
        let lat = result.location.lat;
        handChoose({
          lat: lat,
          lng: lng
        });
        addressList.value = [];
        map.value.centerAndZoom(new T.value.LngLat(lng, lat), 16);
      } else {
        proxy.$modal.msgWarning("定位出错请重新选择");
      }
    }

    /**
     * 确认选择
     */
    function confirm() {
      if (lng.value && lat.value) {
        emit("closeMapaddressDialog", false);
      } else {
        proxy.$modal.msgWarning("鼠标点选或搜索选中地址后再进行确认");
      }
    }
    onMounted(() => {
      initMap();
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
        "label-width": "8rem"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "搜索地址"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(searchAddresKeywords),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(searchAddresKeywords) ? searchAddresKeywords.value = $event : null),
                placeholder: "请输入地点",
                onChange: searchWithName
              }, null, 8, ["modelValue"]), _withDirectives(_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addressList), (item, index) => {
                return _openBlock(), _createElementBlock("div", {
                  key: index,
                  onClick: $event => selectOneAddr(item.address + item.name)
                }, [_createElementVNode("div", null, _toDisplayString(item.address), 1), _createElementVNode("div", null, _toDisplayString(item.name), 1)], 8, _hoisted_3);
              }), 128))], 512), [[_vShow, _unref(addressList) && _unref(addressList).length]])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 16
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "当前地址"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                placeholder: "请输入内容",
                modelValue: _unref(addressInfo).address,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(addressInfo).address = $event)
              }, {
                prefix: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(addressInfo).province) + _toDisplayString(_unref(addressInfo).city) + _toDisplayString(_unref(addressInfo).county), 1)]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "map-containera",
        id: "map-containera"
      }, null, -1))]);
    };
  }
};